import { Author, Review } from "../../types";
import {
  VinoDataReviewer,
  VinoDataSKU,
  VinoDataWine,
} from "../../types/vino-data-types";
import { generateStorefrontImage } from "../../utils/generate-storefront-image";

export const reviewsFromVinoDataWineSKU = (sku: VinoDataSKU): Array<Review> => {
  if (!sku) return [];

  return sku.wines.reduce((acc, wine) => {
    return acc.concat(reviewsFromVinoDataWine(wine));
  }, []);
};

export const reviewsFromVinoDataWine = (wine: VinoDataWine): Array<Review> => {
  const { reviews } = wine;

  return reviews.map((review) => {
    const { reviewer, description } = review;

    return {
      description,
      author: reviewerFromVinoDataReviewer(reviewer),
    };
  });
};

export const reviewerFromVinoDataReviewer = ({
  name,
  title,
  byline,
  image,
}: VinoDataReviewer): Author => {
  return {
    name,
    title,
    byline,
    profileImage: generateStorefrontImage(image, { width: 248 }),
  };
};
